<style lang="less" scoped>

.group {
  .breadcrumb {
    margin: 20px auto;
    width: calc(150vh);
  }

  .chatBox {
    width: calc(150vh);
    max-width: 1600px;
    min-width: 1200px;
    //height: calc(100vh - 100px);
    min-height: 320px;
    margin: 20px auto;
    display: flex;
    border-radius: @border-radius-base;
    background-color: @white;

    .left {
      position: relative;
      // padding:20px 0;
      height: 100%;
      width: 250px;
      min-width: 250px;
      display: flex;
      flex-direction: column;

      .loading {
        position: absolute;
        top: 50%;
        left: 50%;
      }

      // 创建班级
      .addClass {
        top: 20px;
        width: 200px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        background: @primary-color;
        border-radius: 4px;
        border: 1px solid @primary-color;
        color: white;
        cursor: pointer;
        z-index: 9;
        margin: 0 auto;
        margin-top: 10px;
        position: absolute;
        left: 25px;
      }

      .class-name {
        font-size: 16px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #333;
        line-height: 50px;
        height: 80px;
        padding-left: 30px;
        max-width: 200px; /* 设置最大宽度 */
        overflow: hidden;
        text-overflow: ellipsis; /* 使用省略号表示文本溢出 */
        white-space: nowrap; /* 禁止换行 */
      }

      // 班级列表
      .list {
        overflow-y: scroll;
        height: calc(100% - 100px);
        color: #000;
        font-size: 16px;

        .group {
          // padding: 15px 30px;
          border-bottom: dotted 1px #eee;
          font-size: 18px;
          font-weight: bold;
          cursor: pointer;
          display: flex;
          cursor: pointer;
          height: 60px;
          padding-top: 6px;
        }

        .group:hover {
          color: @primary-color;
        }

        .active {
          background-color: #f7f5f0;
          color: @primary-color;
          border-left: 2px solid @primary-color;
          border-bottom: dotted 1px #eee;
          font-size: 18px;
          font-weight: bold;
          cursor: pointer;
          display: flex;
          text-align: center;
          height: 60px;
          padding-top: 6px;
        }
      }
    }

    .right {
      flex-grow: 1;
      height: 100%;
      //width: 950px;
      flex-direction: column;
      justify-content: space-between;
      background-color: #E8E8E8;

      .chat {

        .group-title {
          padding: 10px 20px;
          font-size: 18px;
          font-weight: bold;
          height: 50px;
          // width: 950px;
          display: flex;
          border-bottom: 1px solid #D8D8D8;
          background-color: #E8E8E8;

          .class_name {
            display: inline-block;
            flex: 1;

            .tooltips {
              color: #db5647;
              display: inline-block;
              margin-left: 20px;
              padding-left: 20px;
              padding-right: 15px;
              cursor: pointer;
              background-color: rgba(219, 86, 71, 0.08);
              border-radius: 18px;

              /deep/ .anticon {
                vertical-align: -0.15em;
              }

              .joinClass {
                font-size: 16px;
                margin-left: 10px;
                margin-right: 10px;
                font-weight: normal;
                color: #db5647;

              }
            }

            class_setting {
              flex-shrink: 0;

              .class_setting_img {
                width: 21px;
                height: 21px;
              }
            }
          }
        }

        .messages {
          display: flex;
          flex-direction: column;
          padding: 10px 20px;
          // height: 600px;
          //margin-bottom: 100px;
          overflow: auto;
          //justify-content: space-between;

          .load-more {
            margin-left: auto;
            margin-right: auto;
            width: 150px;
            padding: 3px;
            background-color: #eee;
            border-radius: 10px;
            text-align: center;
            cursor: pointer;
          }

          .message {
            margin: 10px;
            min-height: fit-content;

            .recallMsg {
              margin-right: 10px;
            }

            .message_item_time {
              //  position: absolute;
              // top: -25px;
              // left: 0;
              // right: 0;
              margin: auto;
              width: 124px;
              height: 20px;
              color: #867D7B;
              font-weight: 400;
              font-size: 10px;
              line-height: 20px;
            }

            .body {
              display: flex;

              .user-photo {
                width: 30px;
                height: 30px;
                border-radius: 5px;
                margin: 5px;
              }

              .message-body {
                .user-name {
                  color: #867D7B;
                  margin-left: 5px;
                }

                .messageContentRight {
                  //  border: 1px solid #ddd;
                  //  border-radius: 5px;
                  position: relative;
                  border-radius: 5px;
                  width: 100%;
                  padding: 10px 15px;
                  font-size: 14px;
                  margin-top: 5px;
                  background-color: #A3AF90;
                  //background-image: url("../../../assets/imgs/chat-my_bg.png");
                  //background-image: url("../../../assets/imgs/chat_other_bg.png");
                  background-size: cover;
                  background-repeat: no-repeat;
                  color: #FFFFFF;
                }

                .message-content-right {
                  position: relative;
                  border: 1px solid #ddd;
                  border-radius: 5px;
                  padding: 10px 10px;
                  font-size: 14px;
                  background-color: #A3AF90;
                  //background-image: url("../../../assets/imgs/chat_other_bg.png");
                  color: #FFFFFF;
                }

                .message-content-right::after {
                  content: '';
                  position: absolute;
                  right: -8px;
                  top: 8px;
                  width: 0;
                  height: 0;
                  border-top: 8px solid transparent;
                  border-bottom: 8px solid transparent;
                  border-left: 8px solid #A3AF90;
                }

                .messageContentRight::after {
                  content: '';
                  position: absolute;
                  right: -10px;
                  top: 8px;
                  width: 0;
                  height: 0;
                  border-top: 10px solid transparent;
                  border-bottom: 10px solid transparent;
                  border-left: 10px solid #A3AF90;
                }

                .messageContent {
                  //border: 1px solid #ddd;
                  position: relative;
                  border-radius: 5px;
                  padding: 10px 15px;
                  margin-top: 5px;
                  font-size: 14px;
                  background-color: #fff;
                  max-width: 1200px;
                  //background-image: url("../../../assets/imgs/chat_other_bg.png");
                  background-size: 100% 100%;
                  background-size: cover;
                  color: #000;
                }

                .message-content {
                  //border: 1px solid #ddd;
                  //border-radius: 5px;
                  position: relative;
                  padding: 10px 0px;
                  font-size: 14px;
                  background-color: #fff;
                  color: #FFFFFF;
                }

                .messageContent::before {
                  content: '';
                  position: absolute;
                  left: -20px;
                  top: 8px;
                  width: 0;
                  height: 0;
                  border: solid 10px;
                  border-right-color: #fff;
                  border-top-color: transparent;
                  border-left-color: transparent;
                  border-bottom-color: transparent;
                }

                .message-content::before {
                  content: '';
                  position: absolute;
                  left: -20px;
                  top: 8px;
                  width: 0;
                  height: 0;
                  border: solid 10px;
                  border-right-color: #fff;
                  border-top-color: transparent;
                  border-left-color: transparent;
                  border-bottom-color: transparent;
                }

                .message-time {
                  color: #867D7B;
                  margin-top: 5px;
                  margin-left: 5px;
                }
              }
            }
          }

          .right {
            // margin-left: auto;
            // max-width: 838px;
            word-break: break-all;

            .user-name {
              text-align: right;
            }
          }
        }

        .sent {
          //   position: absolute;
          //  bottom: 0;
          width: 100%;
          padding: 10px 20px;
          height: 140px;
          display: flex;
          flex-direction: column;
          border: 1px solid #D8D8D8;
          background-color: #E8E8E8;
          border-bottom-right-radius: 12px;

          .msg-type-btn {
            font-size: 20px;
            margin: 5px;
            cursor: pointer;
          }

          .sent-content {
            display: flex;
            padding: 10px 0;

            .sengTxt {
              border: none;
              margin-right: 5px;
            }
          }
        }

      }

      .no-class {
        margin-top: 20px;
        text-align: center;
        height: calc(100vh - 190px);
        min-height: 100px;
        // padding-top: 150px;

        //img {
        //  width: 200px;
        //  height: 170px;
        //  text-align: center;
        //}
        .empty-img {
          text-align: center;
          margin: 80px auto 10px auto;
        }

        .no-mess {
          width: 100%;
          height: 26px;
          font-size: 18px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #867D7B;
          line-height: 26px;
          text-align: center;
          margin-top: 20px;
        }
      }
    }

    .user-photo {
      width: 30px;
      height: 30px;
      border-radius: 5px;
      margin: 5px;
    }

    .class-list {
      display: flex;

      img {
        width: 50px !important;
        height: 50px !important;
        border-radius: 50%;
      }
    }
  }
}

.class-info {
  font-size: 18px;
  position: relative;

  .content {
    font-size: 1.1em;
    font-weight: bold;
    margin-bottom: 10px;
    padding: 10px 0;
    border-bottom: 1px solid #EEE;
  }

  .class-name-title {
    margin-bottom: 10px;
    padding: 10px 0;
    height: 26px;
    font-size: 16px;
    color: #867D7B;
    line-height: 26px;
  }

  .class-name {
    min-height: 34px;
    width: 100%;
    font-family: PingFangSC-Regular, PingFang SC;
    line-height: 24px;
    font-size: 16px;
    font-weight: bold;
    margin-top: 15px;
    color: #000000;
    border-bottom: 1px solid #EEE;
  }

  .class-name-input {
    min-height: 34px;
    width: 100%;
    font-family: PingFangSC-Regular, PingFang SC;
    line-height: 24px;
    font-size: 16px;
    font-weight: bold;
    margin-top: 15px;
    color: #000000;
    //border-bottom: 1px solid #EEE;
    //border: none;
    border: none;
    outline: none;
  }

  .class-name-input.focused {
    border: 2px solid @primary-color;
  }

  .class-name-input:focus {
    border: 2px solid @primary-color;
  }

  .class-name-input:not(:focus) {
    border-bottom: 1px solid #EEE;
  }

  .tips3 {
    color: #999;
    font-size: 16px;
    width: 100%;
    align-content: center;
    margin: 10px auto;
    border-top: 1px solid #EEE;
  }

  .text-wrapper_15 {
    border-radius: 4px;
    background: @primary-color;
    text-align: center;
    align-content: center;
    color: #FFFFFF;
    font-size: 14px;
    margin: 20px 0px 0px 110px;
  }

  .member {
    margin-top: 20px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-row-gap: 5px;
    background-color: @white;

    /deep/ .ant-btn {
      width: 50px;
      height: 24px;
      line-height: 24px;
      border: 1px solid @primary-color;
      background: #fff;
      color: @primary-color;
      float: right;
    }

    /deep/ .ant-list-item {
      padding: 5px 0px 0px 0px;
    }

    .mess {
      height: 20px;
      float: right;
      cursor: pointer;
      text-align: right;
      color: @primary-color;
      float: right;

      .text {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #867D7B;
      }

      .zz, .zb {
        cursor: pointer;
        margin-right: 10px;
      }

      .yc {
        cursor: pointer;
      }
    }

    .owner {
      color: blue !important;
      font-weight: bold;

      .del {
        display: none;
      }
    }

    .teacher::before {
      content: '🌷';
      color: @primary-color;
      font-size: 1.2em;
    }

    .inClass {
      border: 2px solid green;
    }

    .del {
      margin-right: 20px;
      float: right;
      color: #db5647;
      cursor: pointer;
    }

    .active {
      //margin-right: 15px;
      float: right;
      color: #ccc;
      cursor: pointer;
      margin: auto 0px;
    }

    .active1 {
      margin-right: 15px;
      float: right;
      color: red;
      cursor: pointer;
      float: right;
      margin-top: 4px;
    }
  }

  .edit {
    width: 20px;
    height: 20px;
    border-radius: 20px;
    color: #fff;
    font-size: 16px;
    float: right;
  }

  .classNumber {
    min-height: 260px;

    .classTop {
      .classGroup {
        /deep/ .ant-col-4 {
          margin-top: 6px;
        }
      }
    }
  }
}

//新建班级
.f-del {
  display: flex;
  width: 180px;
  margin: 20px auto 0;

  .f-c {
    background: #FFFFFF;
    border-radius: 4px;
    border: 1px solid #DBD1CD;
    color: #867D7B;
    height: 30px;
    text-align: center;
    width: 70px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    line-height: 30px;
    text-align: center;
    margin: auto;
    cursor: pointer;
  }

  .f-s {
    background: @primary-color;
    color: #fff;
    border-radius: 4px;
    height: 30px;
    text-align: center;
    width: 70px;
    line-height: 30px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    text-align: center;
    margin: auto;
    cursor: pointer;
  }
}

.applyLi {
  height: 120px;

  .applyName {
    height: 60px;
    line-height: 60px;
    font-size: 16px;
    color: #040506;

    .userImg {
      width: 44px;
      height: 44px;
      border-radius: 50%;
    }

    .userName {
      margin-left: 10px;
      color: @primary-color;
    }

    .name {
      color: #040506;
      margin-left: 10px;
    }

    .className {
      color: #db5647;
      margin-left: 10px;
    }
  }

  .applyFun {
    float: right;

    .sure {
    }

    .refuse {
      margin-left: 20px;
    }
  }
}

//.ant-dropdown-menu {
//  display: flex !important;
//  flex-wrap: wrap;
//  width: 80px !important;
//}

.add-group {
  width: 200px;
  margin: 0 auto;

  .create-a {
    background: @primary-color;
    color: #fff;
    font-size: 14px;
    text-align: center;
    width: 200px;
    height: 48px;
    line-height: 48px;
    border-radius: 4px;
    cursor: pointer;
    margin-top: 8px;
  }

  .create-n {
    background: #F1F0F0;
    color: #040506;
    font-size: 14px;
    text-align: center;
    width: 200px;
    height: 48px;
    line-height: 48px;
    margin-top: 8px;
    border-radius: 4px;
    cursor: pointer;
  }
}

.add-group {
  width: 180px;
  margin: 0 auto;
}

.radom-group {
  width: 180px;
  margin: 0 auto;
  color: #867D7B;

  .top {
    .number {
      color: #333;
    }
  }

  .bot {
    margin-top: 10px;

    /deep/ .ant-input {
      height: 25px;
    }
  }
}

.footer {
  display: flex;
  margin: 0 auto;
  justify-content: space-between;
  margin-top: 30px;

  .cancel {
    width: 80px;
    height: 24px;
    background: #FFFFFF;
    border-radius: 2px;
    border: 1px solid #DBD1CD;
    text-align: center;
    line-height: 24px;
    cursor: pointer;
    color: #867D7B;
  }

  .sure {
    width: 80px;
    height: 24px;
    background: @primary-color;
    border-radius: 2px;
    text-align: center;
    line-height: 24px;
    cursor: pointer;
    color: #FFFFFF;
  }
}

/deep/ .ant-list {
  width: 300px;
}

/deep/ .ant-list-item {
  padding: 10px 0px 10px 0px
}

/deep/ .ant-pagination {
  text-align: center;
}

/deep/ .ant-list-vertical .ant-list-item-meta {
  margin-bottom: 0px;
}

/deep/ .ant-list-item-meta-avatar {
  margin-right: 16px;
  margin-top: -6px;
}

/deep/ .ant-list-split .ant-list-item {
  border-bottom: none;
}

/deep/ .ant-list-something-after-last-item .ant-spin-container > .ant-list-items > .ant-list-item:last-child {
  border-bottom: none;
}
</style>
<template>
  <div class="group">
    <a-breadcrumb class="breadcrumb">
      <a-breadcrumb-item style="font-size: 16px">
        <router-link :to="'/Class'">班级管理</router-link>
      </a-breadcrumb-item>
      <a-breadcrumb-item style="font-size: 16px">
        {{ currentClassName }}
      </a-breadcrumb-item>
    </a-breadcrumb>

    <div class="chatBox">
      <div class="left" :style="{ height: browserHeight+160 + 'px' }">
        <a-spin class="loading" v-show="loading"/>
        <div class="class-name"></div>
        <div class="addClass" @click="addGroup()">+ 创建小组</div>
        <div class="list" v-if="currentGroups!==null&&currentGroups.length>0">
          <div v-for="(c,index) in currentGroups" :key="index"
               :class="currentGroupIndex == index ? 'active' : 'group'" @click="changeClass(c,index)">
            <a-tooltip placement="right" :title="c.groupName">
              <span class="class-name">{{ c.groupName }}</span>
            </a-tooltip>
          </div>
        </div>

        <a-empty v-if="currentGroups===null||currentGroups.length === 0">
          <span slot="description"> 暂无小组 </span>
        </a-empty>
      </div>
      <div class="right">

        <div class="chat" v-if="currentGroups!==null&&currentGroups.length>0">
          <div class="group-title">
            <div class="class_name">
              <span>{{ group.groupName }}（{{ group.count }}人）</span>
            </div>
            <div class="class_setting" ref="aff" id="class_setting">

              <a-tooltip placement="right" title="设置">
                <img src="../../../assets/image/class_setting.png" style="height: 30px;width: 30px" alt="设置"
                     @click="lookSetting"/>
              </a-tooltip>
            </div>
          </div>
          <div class="messages" ref="message" :style="{ height: browserHeight + 'px' }">
            <div class="load-more" v-if="pageNum<totalPages"
                 @click="getHistoryMsg (this.currentGroupId, 2, 1, true)">
              加载更多
            </div>
            <div v-for="(message,index) in groupMessages" :key="message.id" :data-id="message.id"
                 :class="{message:true}">
              <div class="message_item_time">
                {{ handleMsgTimeShow(message.createDate, index) || '' }}
              </div>
              <!-- 撤回消息 -->
              <div v-if="message.status == 'recall'" class="body">
                <!--                <img v-if="message.from !== userId" :src="getUserPhoto(message)" class="user-photo"/>-->
                <!--                <div class="message-body">-->
                <!--                  <div class="user-name">-->
                <!--                    {{ message.fromName }}{{ message.fromUserName }}-->
                <!--                  </div>-->
                <!--                     <div style="text-align: right">-->
                <!--                       {{ message.msg }}-->
                <!--                     </div>-->
                <!--                  <div  class="message-time">-->
                <!--                    {{-->
                <!--                      format.format(Number(message.createDate))-->
                <!--                    }}-->
                <!--                  </div>-->
                <!--              </div>-->
                <!--                <img v-if="message.from === userId"-->
                <!--                     :src="userPhoto&&userPhoto!=null?$userINfoBasePath +'/'+ userPhoto: mrImg" class="user-photo"/>-->
                <div style="text-align: center;margin: auto">
                  {{ message.fromName }}{{ message.fromUserName }}{{ message.msg }}
                </div>
              </div>
              <a-dropdown
                  v-else
                  :trigger="['contextmenu']"
                  :style="{ float: message.from === userId ? 'right' : 'left' }"
                  :disabled="message.status == 'recall'"
              >
                <div class="body">
                  <img v-if="message.from !== userId" :src="getUserPhoto(message)" class="user-photo"/>
                  <div class="message-body">
                    <div class="user-name">
                      {{ message.fromName || message.fromUserName || message.ext.nikeName }}
                    </div>
                    <div v-if="(message.type==='txt'||message.msgType==='txt')&&message.msg"
                         :class="{messageContent:message.from !== userId,messageContentRight:message.from === userId}"
                         v-html="renderTxt(message.msg)"></div>
                    <div v-else-if="message.type==='img'||message.msgType==='img'" class="cursor-pointer">
                      <img :src="(message.url).startsWith('http')?message.url:resBasePath + message.url"
                           @click='preview(message)'
                           style="width:300px;border-radius:5px;"/>
                    </div>
                    <div v-else-if="message.type==='audio'||message.msgType==='audio'"
                         class="message-content">
                      <audio id="my-audio" ref="myAudio"
                             :src="(message.url).startsWith('http')?message.url:resBasePath + message.url" controls>
                      </audio>
                    </div>
                    <div v-else-if="message.type==='video'||message.msgType==='video'" class="message-content">
                      <video :src="(message.url).startsWith('http')?message.url:resBasePath + message.url"
                             width="300px" controls></video>
                    </div>
                    <a-card style="width: 300px" title="文件"
                            v-else-if="(message.type==='file'||message.msgType==='file') && message.url"
                            class="message-content">
                      <div slot="extra" class="flex-row align-center">
                        <a-button @click="preview(message)" type="link" block>
                          预览
                        </a-button>
                        <!--                        <a style="width:100%"-->
                        <!--                           :href="(message.url).startsWith('http')?message.url:resBasePath + message.url"-->
                        <!--                           :download="message.filename">下载</a>-->
                        <a-button @click="download(message)" type="link" block>
                          下载
                        </a-button>
                      </div>
                      <p style="word-break: break-word;color: black">{{ message.filename }}</p>
                      <p v-if="message.fileLength" style="word-break: break-word;color: black">
                        {{ getFileSize(message.fileLength) }}</p>
                      <p v-else-if="message.file_length" style="word-break: break-word;color: black">
                        {{ getFileSize(message.file_length) }}</p>
                    </a-card>
                    <a-card v-else title="文件" style="width: 300px">
                      <div slot="extra" class="flex-row align-center">
                        <!--                 <a-button @click="withdraw(message)" type="link" block>-->
                        <!--                  撤销-->
                        <!--                </a-button>-->
                        <a style="width:100%" :href="resBasePath + message.url" :download="message.filename">下载</a>
                      </div>
                      <p style="color: black">{{ message.filename }}</p>
                      <p>{{ getFileSize(message.fileLength) }}</p>
                    </a-card>
                    <!--                    <div class="message-time" v-if="message.createDate">{{-->
                    <!--                        format.format(Number(message.createDate))-->
                    <!--                      }}-->
                    <!--                    </div>-->
                    <!--                    <div class="message-time" v-else-if="message.time">{{ format.format(Number(message.time)) }}</div>-->
                  </div>
                  <img v-if="message.from === userId"
                       :src="userPhoto&&userPhoto!=null?$userINfoBasePath +'/'+ userPhoto: mrImg" class="user-photo"/>
                </div>
                <a-menu slot="overlay" v-show="message.from === userId">
                  <a-menu-item key="1" @click="recallMessage(message)">撤回</a-menu-item>
                  <!--                <a-menu-item v-else key="2" @click="()=>{setReportMsgId(message.mid)}">举报</a-menu-item>-->
                </a-menu>
              </a-dropdown>
            </div>
          </div>
          <div class="sent">
            <div>
              <a-dropdown :trigger="['click']" placement="topLeft">
                <a-icon class="msg-type-btn" type="smile"/>
                <a-menu slot="overlay" style="width: 400px;display: flex;flex-wrap: wrap;">
                  <a-menu-item v-for="(emoji,index) in emojiList" :key="index" @click="selectEmoji(index)"><img
                      :src="`faces/${emoji}`"/>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
              <a-icon @click="clickUpload()" class="msg-type-btn" type="folder-open"/>
              <!-- <a-icon @click="openRecorder()" class="msg-type-btn" type="audio" /> -->
            </div>
            <div class="sent-content">
              <a-textarea v-model="msgText" equired placeholder="输入消息，按Enter键发送，Ctrl+Enter换行。" class="sengTxt"
                          @keydown.enter.native="debounceSendOrNewLine($event)"
                          style="resize:none;height: 80px;background: #E8E8E8" ref="txtDom" :rows="1"/>
              <input @change="fileChange" type="file" multiple style="display:none" ref="uploadDom"/>
              <!--              <a-button @click="sendTextMsg" :disabled="msgText===''">发送</a-button>-->
            </div>
          </div>
        </div>
        <div class="no-class" v-if="currentGroups===null||currentGroups.length === 0">
          <img class="empty-img" src="../../../assets/imgs/08.png" style="height: 300px;width: 300px;text-align: center"
               alt="">
          <div class="no-mess">暂无小组，快去创建小组吧</div>
        </div>
      </div>
    </div>

    <!-- 小组详情-->
    <a-drawer title="" width="360px" @close="classInfoVisible = false" :visible="classInfoVisible" footer=""
              :maskClosable="true" placement="right"
              :dialogStyle="dialogStyle" :mask="true" :closable="false">
      <template>
        <div class="class-info">
          <div class="class-name-title">
            小组名称
            <!--            <a-icon type="eye" class="edit" @click="addNewClass"/>-->
            <img src="../../../assets/image/class-edit.png" class="edit" alt="小组" @click="addNewClass"/>
          </div>
          <!--          <div class="class-name">-->
          <!--            {{ classInfo.className || classInfo.groupname }}-->
          <!--          </div>-->
          <input class="class-name-input" v-model="inputclassName" placeholder="小组名称" type="text" @blur="onBlur"
                 id="myInput"/>
          <!--          <div class="class-name-title">-->
          <!--            班级公告-->
          <!--            <img src="../../../assets/image/class_group.png" class="edit" alt="小组" @click="showClassNotice"/>-->
          <!--          </div>-->
          <!--          <div class="class-name">-->
          <!--            {{ classInfo.intro || '暂无公告！' }}-->
          <!--          </div>-->
          <!--          <div class="class-name-title">班级ID</div>-->
          <!--          <div class="class-name">{{ classInfo.id || classInfo.groupid }}</div>-->
          <!--          <div class="class-name-title">班级二维码</div>-->
          <!--          <div class="class-name" ref="qrcode" style="border:none;"></div>-->
          <div class="class-name-title">
            小组成员
            <!--            <img src="../../../assets/image/class_group.png" class="edit" alt="小组" @click="lookGroup"/>-->
          </div>
          <a-input-search placeholder="搜索小组成员" style="width: 315px;margin-top: 10px" @search="onSearch"
                          :allowClear="true"/>
          <div class="member">
            <a-list itemLayout="vertical" :pagination="pagination" :data-source="members">
              <a-list-item slot="renderItem" slot-scope="item">
                <a-list-item-meta>
                  <div slot="title" :class="{owner:item.owner}">
                    <span v-show="item.isTea===0">{{ item.userName || item.member || item.owner }}</span>
                    <span v-show="item.isTea===1">{{ item.userName || item.member || item.owner }}（老师）</span>
                    <!--                    <img class="mess" @click="messForbden(item)" :src="item.isForbidden==0?speak:noSpeak" alt=""/>-->
                    <div class="mess" v-show="item.isTea===0">
                      <!--                      <span class="zz" v-show="item.isGroupLeader===0" @click="zzFun(item)">设为组长</span>-->
                      <span class="zb" @click="zbFun(item)">转组</span>
                      <span class="yc" @click="ycFun(item)">移除</span>
                    </div>
                  </div>
                  {{ item }}
                  <a-avatar slot="avatar" :src="item.photo?$userINfoBasePath +'/'+item.photo:mrImg"/>
                </a-list-item-meta>
              </a-list-item>
            </a-list>
          </div>
          <div class="tips3">
            <a-button class="text-wrapper_15" @click="dissolveClass">解散小组</a-button>
          </div>

          <a-modal class="classNumber" v-model="addClassModel" width="440px" title="修改小组名称" @ok="addNewClassFun"
                   @cancel="cancelNewClass" destroyOnClose>
            <a-row class="classTop">
              <a-col :span="4" class="classGroup">小组名:</a-col>
              <a-col :span="20">
                <a-input class="newName" v-model="newClassName"/>
              </a-col>
            </a-row>
          </a-modal>
        </div>

      </template>
    </a-drawer>
    <!-- 创建小组-->
    <a-modal title="创建小组" width="360px" :visible="newGroupVis" footer="" @cancel="()=>{this.newGroupVis = false}"
             :centered="true">
      <template>
        <div class="add-group">
          <div :class="currentCreateIndex === index ? 'create-a' :'create-n'" v-for="(item,index) in createList"
               :key="index" @click="createGroupFun(index)">
            {{ item.name }}
          </div>
        </div>
        <div class="footer" style="width:200px">
          <div class="cancel" @click="cancelFun">取消</div>
          <div class="sure" @click="sureFun">确认</div>
        </div>
      </template>
    </a-modal>
    <!-- 随机分组-->
    <a-modal title="随机分组" width="360px" :visible="radomVis" footer="" @cancel="() => { this.radomVis = false}"
             :centered="true">
      <template>
        <div class="radom-group">
          <div class="top">
            <span>班级总人数：</span><span class="number">{{ classMemberNumber }} &nbsp;人</span>
          </div>
          <div class="bot">
            <span>小组数量：</span>
            <a-input v-model="groupNumber" style="width: 60px;margin-left:10px;"/> &nbsp;组
          </div>
        </div>
        <div class="footer" style="width:180px">
          <div class="cancel" @click="radomCancelFun">取消</div>
          <div class="sure" @click="debounceRadomSureFun">确认</div>
        </div>
      </template>
    </a-modal>
    <!-- 转组-->
    <a-modal title="转组" width="460px" :visible="zbVis" @cancel="classCancel" @ok="groupChangeOk" :centered="true">
      <template>
        <div>
          <span>转入群组</span>
          <a-select placeholder="请选择您要转入的小组" style="width: 320px;margin-left: 20px;" @change="groupChange"
                    :centered="true">
            <a-select-option v-for="(item,index) in currentGroups" :value="item.id" :key="index">
              {{ item.groupName }}
            </a-select-option>
          </a-select>
        </div>
      </template>
    </a-modal>
    <!-- 移除-->
    <a-modal title="移除" width="460px" :visible="ycVis" @cancel="ycCancel" @ok="ycOk" :centered="true">
      <template>
        <div class="del-name">是否把{{ delMess.userName }}移除该组？</div>
      </template>
    </a-modal>

    <file-preview :visible.sync="previewVisible" v-if="previewVisible" :file="previewFile"></file-preview>
  </div>
</template>

<script>
import requestUrl from '../../../utils/requestUrl.js'
import shareState from '../../../utils/shareState.js'
import WebIM from '../../../utils/WebIM'
import format from '../../../utils/format.js'
import emoji from '../../../utils/emoji.js'
import { getFileType, getFileSize } from '../../../utils/getFileInfo.js'
import QRCode from 'qrcodejs2'
import speak from '@/assets/image/41-1.png'
import noSpeak from '@/assets/image/41-2.png'
import axios from 'axios'
import FilePreview from '../../../components/FilePreview'
import { debounce } from 'lodash' // 导入防抖函数

export default {
  name: 'Groups',
  components: {
    FilePreview
  },
  watch: {
    groupMessages (val) {
      console.log(val)
      this.scrollTo()
    },
    groupid () {
      this.getHistoryMsg(this.currentGroupId, 2, 1, true)
    }

  },
  data () {
    return {
      requestUrl,
      userId: this.$store.state.userInfo.id,
      access_token: localStorage.getItem('access_token'),
      loading: false,
      currentModule: 'Chat',
      currentGroupId: '',
      newClassName: '',
      classNotice: '',
      newGroupVis: false,
      // 班级信息弹窗展示
      classInfoVisible: false,
      addClassModel: false,
      // 班级公告
      classNoticeVis: false,
      classInfo: {
        className: '',
        id: '',
        intro: '暂无公告！'
      },
      imGroupList: [],
      classList: [], // 班级列表
      currentClassId: localStorage.getItem('classId'), // 当前班级id
      currentClassName: localStorage.getItem('className'),
      currentClass: {}, // 当前班级对象
      currentGroups: [], // 当前班级对象
      speak,
      noSpeak,
      members: [
        // { userName: '张三', isForbidden: 0, photo: '' },
        // { userName: '李四', isForbidden: 0, photo: '' },
        // { userName: '王五', isForbidden: 1, photo: '' }
      ],
      // 班级成员+IM群组成员
      pagination: {
        onChange: page => {
          // console.log(page);
        },
        pageSize: 10
      },
      currentGroupIndex: 0,
      mrImg: require('../../../assets/imgs/student.png'),
      resBasePath: this.$resBasePath + '/',
      shareData: shareState.state,
      format,
      getFileType,
      getFileSize,
      groupid: '',
      msgText: '',
      msgType: 'txt',
      userName: '',
      userPhoto: '',
      emojiList: emoji.obj,
      previewVisible: false,
      previewFile: { name: '', url: '' },
      recoderVisible: false,
      randomheight: [30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30],
      recorder: null,
      recConfig: {
        sampleBits: 16,
        sampleRate: 11025,
        numChannels: 1
      },
      isRecording: false,
      totalRecTime: 60,
      remainingRecTime: 60,
      pageNum: 1,
      // 按照要求修改为100
      pageSize: 500,
      totalPages: 1,
      msgRecordType: 1,
      timestamp: new Date().getTime(),
      chatLoading: false,
      group: { groupName: '', count: 0 },
      // 班级信息弹框位置
      dialogStyle: {
        top: '190px',
        right: '-450px'
      },
      applyList: [],
      applyVisible: false,
      isStudentJoin: false, // 是否有学生加入
      applyParam: null, // 学生加入班级同意或者拒绝参数
      currentCreateIndex: 0,
      radomVis: false,
      newClassVis: false,
      createList: [
        { name: ' 创建小组' },
        { name: ' 随机分组' }
      ],
      classMemberNumber: 0,
      groupNumber: '',
      zbVis: false,
      ycVis: false,
      delMess: {}, // 移除人的信息
      changeGroupId: '',
      changUserId: '', // 要转的个人ID
      inputclassName: '',
      browserHeight: 500
    }
  },
  computed: {
    groupMessages () {
      // 从消息记录中获取本群组的消
      // const messages = this.shareData.msgList.filter((msg) => msg.to === this.groupid)
      const messages = this.shareData.msgList.filter((msg) => msg.to === this.groupid).sort((a, b) => new Date(a.createDate) - new Date(b.createDate))
      // console.log(messages)
      return messages || []
    }
  },
  mounted () {
    this.getClassList()
    this.getImInfo()
    this.browserHeight = window.innerHeight - 350
    console.log('浏览器高度：', this.browserHeight - 300)
  },
  methods: {

    onSearch (value) {
      if (value !== '') {
        const messages = this.members.filter((msg) => msg.userName.includes(value))
        this.members = messages
      } else {
        this.getClaMembersByClassId()
      }
    },
    addEventListener () {
      const input = document.getElementById('myInput')
      input.addEventListener('focus', function () {
        this.classList.add('focused')
      })
      input.addEventListener('blur', function () {
        this.classList.remove('focused')
      })
    },
    onBlur () {
      console.log('失去焦点')
      this.addNewClassFun()
    },
    addGroup () {
      console.log('addGroup')
      this.newGroupVis = true
    },
    getImInfo () {
      console.log('登陆环信-group', 'getImInfo')
      console.log('登陆环信-group', 'getImInfo-loginWebIm-' + this.shareData.imUserInfo)
      // 获取用户IM注册信息
      if (this.shareData.imUserInfo) {
        this.loginWebIm(this.shareData.imUserInfo)
        return
      }
      const param = {
        access_token: this.access_token,
        userId: this.userId
      }
      this.$http.post(requestUrl.getUserLoginToken, param).then(res => {
        if (res) {
          shareState.setImUserInfo({
            access_token: res.access_token,
            expires_in: res.expires_in,
            user: res.user
          })
          this.loginWebIm()
        }
      })
    },
    updateMessages (message, msgType) {
      console.log(message)
      const fromUserName = message.ext.nikeName
      const fromUserPhoto = message.ext.avatar ? this.$userINfoBasePath + '/' + message.ext.avatar : 'imgs/logo.png'
      const receivedMsg = Object.assign(message, {
        msg: msgType === 'txt' ? message.sourceMsg : message.url,
        fromUserName,
        fromUserPhoto,
        chatType: 'groupChat',
        msgType: msgType,
        bySelf: false,
        status: 'received'
      })
      shareState.setMsgList(receivedMsg)
    },
    recallMessages (message) {
      console.log(message)
      const fromUserName = message.ext.nikeName
      const fromUserPhoto = message.ext.avatar ? this.$userINfoBasePath + '/' + message.ext.avatar : 'imgs/logo.png'
      const receivedMsg = Object.assign(message, {
        msg: '撤回消息',
        fromUserName,
        fromUserPhoto,
        chatType: 'groupChat',
        msgType: 'txt',
        bySelf: false,
        status: 'recall'
      })
      shareState.setMsgList(receivedMsg)
    },
    showLoginAnother () {
      const vm = this
      vm.$confirm({
        title: '异地登录提示',
        content: '账号在其他设备登录，请重新登录',
        cancelButtonProps: { style: { display: 'none' } },
        onOk () {
          window.localStorage.clear()
          sessionStorage.clear()
          localStorage.clear()
          // vm.$router.push({ name: 'Login' })
          console.log(process.env.NODE_ENV)
          window.location.replace(vm.$loginUrl)
        }
      })
    },
    loginWebIm () {
      const options = {
        apiUrl: WebIM.config.apiURL,
        user: this.shareData.imUserInfo.user.username,
        accessToken: this.shareData.imUserInfo.access_token,
        appKey: WebIM.config.appkey
      }
      const vm = this
      WebIM.conn.open(options)
      WebIM.conn.listen({
        onOpened: function (message) {
          // 连接成功回调
          vm.loading = false
          // vm.getGroupList()
        },
        onClosed: function (message) {
          vm.loading = true
          // vm.$message.error('您在其他地方登录帐号，请重新登录', '')
          console.log('环信连接失败-group', message)
          if (message.type == 206) {
            vm.showLoginAnother()
          } else {
            vm.$message.error(message.message, '')
          }
        },
        onReceivedMessage: function (message) {
          // 收到文件消息
          console.log('收到onReceivedMessage消息', message)
          const recall = vm.shareData.msgList.find((msg) => msg.msgId == message.id)
          recall.mid = message.mid
          console.log('更新消息', recall)
          // vm.updateMessagesId(recall, message.mid)
        },
        onTextMessage: function (message) {
          // 收到文本消息
          vm.updateMessages(message, 'txt')
          console.log('收到文本消息', message.time.length, message)
        },
        onPictureMessage: function (message) {
          // 接收图片消息
          vm.updateMessages(message, 'img')
        },
        onAudioMessage: function (message) {
          // 收到音频消息
          console.log('收到音频消息', message)
          vm.updateMessages(message, 'audio')
        },
        onFileMessage: function (message) {
          // 收到文件消息
          console.log('收到文件消息', message)
          vm.updateMessages(message, 'file')
        },
        onVideoMessage: function (message) {
          // 收到视频消息
          console.log('收到视频消息', message)
          vm.updateMessages(message, 'video')
        },
        onRecallMessage: function (message) {
          // 收到消息撤回回执
          console.log('消息撤回回执', message)
          console.log('消息撤回-messageid=', message.mid)
          console.log('本地消息', vm.shareData.msgList)
          const recall = vm.shareData.msgList.find((msg) => msg.id == message.mid)
          console.log('收到消息撤回回执', recall)
          if (recall) {
            // vm.recallMessages(recall)
            recall.status = 'recall'
            recall.msg = '撤回了一条消息'
          }
        },
        onError: function (error) {
          console.log('环信异常-group', error)
          if (error.type == 206) {
            vm.showLoginAnother()
          } else {
            vm.$message.error(error.message, '')
          }
        }
      })
    },
    /**
     * 点击切换小组
     */
    changeClass (classMess, index) {
      this.currentGroupIndex = index
      this.currentGroupId = classMess.id
      this.groupid = classMess.groupTag
      this.group.count = classMess.count
      this.group.groupName = classMess.groupName
      this.timestamp = new Date().getTime()
      this.getHistoryMsg(this.currentGroupId, 2, 1, true)
    },

    /**
     * 获取用户班级列表及班级小组
     */
    getClassList () {
      this.$http.post(requestUrl.getV3MyClassAndClassGroup, {
        access_token: this.access_token,
        userId: this.userId
      }).then((res) => {
        if (res) {
          // console.log(res)
          this.classList = res
          this.currentClass = this.classList.find((item) => item.id === this.currentClassId)
          this.classMemberNumber = this.currentClass.studentCount
          this.currentGroups = this.currentClass.groups
          // console.log(this.currentGroups)
          // console.log(this.classMemberNumber)
          // console.log(this.currentClass)

          if (this.currentGroups && this.currentGroups.length > 0) {
            this.currentGroupId = this.currentGroups[this.currentGroupIndex].id
            this.groupid = this.currentGroups[this.currentGroupIndex].groupTag
            this.group.groupName = this.currentGroups[this.currentGroupIndex].groupName
            this.group.count = this.currentGroups[this.currentGroupIndex].count
            this.timestamp = new Date().getTime()
            this.getHistoryMsg(this.currentGroupId, 2, 1, true)
          }
        }
      })
    },
    /**
     * 获取班级公告
     */
    getClassAnnouncement () {
      // 根据班级id 获取班级总人数
      this.$http.post(requestUrl.getClassAnnouncement, {
        access_token: this.access_token,
        userId: this.userId,
        classId: this.currentClassId
      }).then((res) => {
        if (res) {
          this.classInfo.intro = res.content
        }
      })
    },
    /**
     * 获取小组成员
     */
    getClaMembersByClassId () {
      // 获取班级成员
      this.$http.post(requestUrl.getClassGroupMembers, {
        access_token: this.access_token,
        id: this.currentGroupId
      }).then((res) => {
        if (res) {
          this.members = res
        }
      })
    },
    lookGroup () {
      console.log('lookGroup')
      this.$http.post('ebook/res/class/getClassList', {
        access_token: this.access_token,
        userId: this.userId,
        classId: this.currentClassId
      }).then((res) => {
        if (res) {
          this.$store.commit('setClassList', res)
        }
      })
    },
    /**
     * 点击展示班级信息弹窗
     */
    lookSetting () {
      this.classInfoVisible = true
      this.classInfo.className = this.group.groupName
      this.classInfo.id = this.currentClassId
      this.classInfo.intro = '暂无公告！'
      this.inputclassName = this.group.groupName
      // this.getClassAnnouncement()
      this.getClaMembersByClassId()
      // this.creatQrCode(this.currentClassId)
      this.addEventListener()
    },
    lookApply () {
      this.applyVisible = true
    },
    addNewClass () {
      // 修改班级名称弹窗
      //  this.addClassModel = true
      document.getElementById('myInput').focus()
    },
    cancelNewClass () {
      // 修改班级名称弹窗
      this.addClassModel = false
    },
    showClassNotice () {
      // 修改班级名称弹窗
      this.classNoticeVis = true
    },
    creatQrCode (id) {
      if (this.qrcode) {
        this.qrcode.clear()
        this.qrcode.makeCode(id)
        return
      }
      this.qrcode = new QRCode(this.$refs.qrcode, {
        text: id, // 需要转换为二维码的内容
        width: 130,
        height: 130,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H
      })
    },
    /**
     * 解散小组
     */
    dissolveClass () {
      const _this = this
      _this.$confirm({
        title: '解散小组',
        content: '小组解散后,发布的学习任务数据会同步删除。您确认解散小组吗？',
        okText: '确认',
        cancelText: '取消',
        onOk () {
          // return new Promise((resolve, reject) => {
          //   _this.$http.post(requestUrl.dissolveClassGroup, {
          //     access_token: _this.access_token,
          //     id: _this.currentGroupId
          //   }
          //   ).then((res) => {
          //     if (res) {
          //       _this.$message.success('解散成功')
          //       _this.getClassList()
          //       this.classInfoVisible = false
          //       resolve(res)
          //     }
          //   })
          // })
          return new Promise((resolve, reject) => {
            _this
              .$fetch({
                url: _this.$baseUrl + _this.requestUrl.dissolveClassGroup,
                body: {
                  access_token: _this.access_token,
                  id: _this.currentGroupId
                }
              })
              .done((res) => {
                resolve(res)
              })
          }).then((res) => {
            if (res && res.success && res.resultCode === '0') {
              _this.$message.success('解散成功')
              _this.getClassList()
              _this.classInfoVisible = false
            }
          })
        },
        onCancel () {
        }
      })
    },
    getHistoryMsg (targetId, msgRecordType, pageNum, scrollTop = true) {
      const _this = this
      _this.chatLoading = true
      // 按照要求pageNum传固定值 “1”
      this.pageNum = 1
      this.$fetch({
        url: this.$httpConfig.pageClassGroupChatMsgHistoryList,
        body: {
          targetId,
          msgRecordType,
          timestamp: this.timestamp,
          pageSize: this.pageSize,
          access_token: _this.access_token,
          pageNum
        }
      })
        .done((res) => {
          // console.log(res)
          _this.chatLoading = false
          if (!res.success) return
          this.totalPages = res.resultData.pages
          const msg = res.resultData.list.map((m) => {
            m.file = {
              size: m.fileLength,
              name: m.filename,
              url: m.url || ''
            }
            m.ext = {
              avatar: m.fromPhoto,
              nikeName: m.fromName
            }
            m.msgType = m.type
            return m
          })
          shareState.setMsgList(msg, scrollTop)
          if (scrollTop) {
            this.scrollTo()
          }
          _this.$forceUpdate()
          // 记录最后一条消息时间戳，下次调用接口使用
          // if (res.resultData.list != null && res.resultData.list.length > 1) {
          //   this.timestamp = res.resultData.list[res.resultData.list.length - 1].createDate
          // }
        })
    },
    selectEmoji (e) {
      // 选择并发送表情消息
      this.msgText = e
      this.sendTextMsg()
    },
    messForbden (item) {
      // 班级禁言
      // console.log(item)
      // this.groupId = this.$route.params.groupid
      // 获取群组ID
      // console.log(this.groupId)
      // console.log(localStorage.getItem('classID'))
      const _this = this
      const url = item.isForbidden === 0 ? requestUrl.setForbiddenWords : requestUrl.cancelForbiddenWords
      this.$http.post(url, {
        access_token: this.access_token,
        classId: this.currentClassId,
        forbiddenType: '1',
        groupId: '',
        userId: item.id
      }).then((res) => {
        if (res) {
          _this.getClaMembersByClassId()
        }
      })
    },
    /**
     * 修改小组名称
     */
    addNewClassFun () {
      if (this.inputclassName === this.classInfo.className) {
        return false
      }
      if (!this.inputclassName || this.inputclassName === '') {
        this.$message.warning('请您输入小组名称')
        return false
      }
      if (this.inputclassName.length > 16) {
        this.$message.warning('请您输入小组名在16个汉字以内')
        return
      }
      const _this = this
      this.$http.post(requestUrl.updateClassGroupName, {
        access_token: this.access_token,
        name: this.inputclassName,
        id: this.currentGroupId
      }).then((res) => {
        if (res) {
          _this.$message.success('修改小组名称成功')
          _this.addClassModel = false
          _this.classInfo.className = this.inputclassName
          _this.group.groupName = this.inputclassName
          _this.currentGroups[this.currentGroupIndex].groupName = this.inputclassName
        }
      })
    },
    fileChange (e) {
      console.log(e)
      if (e && e.target && e.target.files && e.target.files.length > 0) {
        // const target = e.target;
        // const file = WebIM.utils.getFileUrl(target);
        // 也可将文件自行处理成该格式。
        // let file = {
        //    data: file              file 对象。
        //    filename: 'fileName',   文件名称。
        //    filetype: 'filetype',   文件类型。
        // }
        const files = []
        for (let i = 0; i < e.target.files.length; i++) {
          const file = {
            data: e.target.files[i],
            filename: e.target.files[i].name,
            filetype: e.target.files[i].type
          }

          if (!file || file.data.size === 0) {
            this.$message.info('不能上传空文件！')
            return false
          }
          if (file.data.size / 1024 / 1024 > 10) {
            this.$message.info('文件大小不能超过10M，请压缩后上传！')
            return false
          }
          files.push(file)
        }

        for (let i = 0; i < files.length; i++) {
          const file = files[i]
          const type = getFileType(file.filetype)
          if (type === 'audio' || type === 'video') file.duration = 60
          this.sentMessage('', file, type)
        }
      }
    },
    scrollTo () {
      // 聊天记录区域滚动条滚动至最底部
      const msgdiv = this.$refs.message
      setTimeout(() => {
        if (msgdiv) {
          msgdiv.scrollTop = msgdiv.scrollHeight
        }
        // if (this.shareData.scrollToTop) {
        //   if (msgdiv) {
        //     msgdiv.scrollTop = 0
        //   }
        // } else {
        //   if (msgdiv) {
        //     msgdiv.scrollTop = msgdiv.scrollHeight
        //   }
        // }
      }, 100)
    },
    sentMessage (msg = '', file = null, msgType) {
      // 发送消息；msg消息文本；file消息文件；msgType消息类型（txt，img，file，audio，video）
      // if(this.shareData.imGroupList.length===0) return
      const vm = this
      const _this = this
      const time = +new Date()
      vm.msgType = msgType
      const id = WebIM.conn.getUniqueId()
      // eslint-disable-next-line new-cap
      const msgObj = new WebIM.message(msgType, id)
      let option = {
        to: this.groupid,
        chatType: 'groupChat',
        ext: {
          nikeName: shareState.state.name || this.$getUserInfo().name || '',
          avatar: shareState.state.userPhoto || this.$getUserInfo().userPhoto || ''
        }
      }
      // console.log('vm.userId',vm.userId,)
      // console.log('option',option)
      if (msg) option = Object.assign(option, { msg: this.msgText })
      if (file) option = Object.assign(option, { file: file, ext: { ...option.ext, file_length: file.data.size } })
      // console.log(option);
      msgObj.set({
        ...option,
        onFileUploadError: function (error) {
          vm.$message.error('图片上传失败', error)
        },
        onFileUploadComplete: function (data) {
          // console.log(data);
          const url = data.uri + '/' + data.entities[0].uuid
          // console.log('url', url)
          // console.log(file);
          option.msg = url
          if (vm.msgType !== 'txt') {
            const formData = new FormData()
            formData.append('file', file.data)
            formData.append('customDir', 'hytc_ebook_server/file/chatGourp')
            formData.append('access_token', _this.access_token || '')
            axios({
              url: _this.$uploadUrl,
              method: 'post',
              data: formData,
              headers: { 'Content-Type': 'multipart/form-data' }
            }).then((res) => {
              console.log(res)
              if (res && res.data && res.data.url) {
                const message = {
                  ...option,
                  from: vm.userId,
                  type: vm.msgType,
                  msgId: id,
                  filename: file.filename,
                  fileLength: file.data.size,
                  secret: data.entities[0]['share-secret'],
                  url: res.data.url,
                  createDate: time
                }

                // console.log(message);
                vm.saveMsg(message)
                shareState.setMsgList(message)
                vm.recoderVisible = false
              }
            })
          }
        },
        success: function () {
          // 更新消息列表
          // console.log('vm.msgType', vm.msgType === 'txt')
          // window._czc.push(['_trackEvent', '班级群聊', '发送消息', vm.msgType])
          if (vm.msgType === 'txt') {
            console.log('vm.msgType1', vm.msgType === 'txt')
            const message = {
              ...option,
              from: vm.userId,
              type: vm.msgType,
              msgId: id,
              createDate: time
            }
            console.log('message', message)
            vm.saveMsg(message)
            shareState.setMsgList(message)

            // vm.$store.commit('setMsgList', message);
            vm.msgText = ''
          }
          vm.scrollTo()
        },
        fail: function (e) {
          vm.$message.error('发送失败！' + e)
        }
      })
      console.log('msgObj.body', msgObj.body)
      WebIM.conn.send(msgObj.body)
    },
    sendOrNewLine (event) {
      if (event.metaKey) { // 检测是否同时按下了 Command 键
        this.msgText += '\n' // 换行
        console.log('换行')
      } else {
        // 发送消息到后端
        console.log('Sending message:', this.msgText)
        // 清空输入框
        this.sendTextMsg()
      }
    },
    debounceSendOrNewLine: debounce(function (event) {
      // 在这里编写发送消息的逻辑
      // 执行发送消息的操作
      this.sendOrNewLine(event)
      // 重置输入框
    }, 800),
    sendTextMsg () {
      // 发送文本消息
      if (this.msgText === '' || this.msgText === '\n') {
        this.msgText = ''
        this.$message.info('不能发送空消息！')
        return false
      }
      this.sentMessage(this.msgText, null, 'txt')
    },
    saveMsg (msg) {
      const param = {
        msgRecordType: 2,
        targetId: this.currentGroupId,
        ...msg
      }
      this.$fetch({
        url: this.$httpConfig.saveClassGroupChatMsgHistory,
        body: param
      }).done((res) => {
        console.log(res)
      })
    },
    preview (message) {
      // 图片消息放大预览
      // console.log(message);
      this.previewFile = {
        name: message.filename,
        url: (message.url).startsWith('http') ? message.url : this.resBasePath + '/' + message.url
      }
      this.previewVisible = true
    },
    download (message) {
      const filePath = (message.url.search('http') > -1 ? '' : this.$resBasePath) + '/' + message.url
      const x = new XMLHttpRequest()
      x.open('GET', filePath, true)
      x.responseType = 'blob'
      x.onload = function (e) {
        var url2 = window.URL.createObjectURL(x.response)
        var a = document.createElement('a')
        a.href = url2
        a.download = message.filename
        a.click()
      }
      x.send()
    },
    clickUpload () {
      const upload = this.$refs.uploadDom
      upload && upload.click()
    },
    getUserPhoto (message) {
      const reg = RegExp(/http/)
      if (message.ext?.avatar) {
        // 环信扩展消息带来的头像
        if (reg.test(message.ext?.avatar)) {
          return message.ext?.avatar
        } else {
          return this.$userINfoBasePath + '/' + message.ext?.avatar
        }
      } else if (message.fromPhoto) {
        // 本地服务器上传的头像
        if (reg.test(message.fromPhoto)) {
          return message.fromPhoto
        } else {
          return this.$userINfoBasePath + '/' + message.fromPhoto
        }
      } else {
        return this.mrImg
      }
    },
    renderTxt (txt = '') {
      // 处理并显示表情符号
      const rnTxt = []
      let match = null
      const regex = /(\[.*?\])/g
      let start = 0
      let index = 0
      while ((match = regex.exec(txt))) {
        index = match.index
        if (index > start) {
          if (txt != null) {
            rnTxt.push(txt.substring(start, index))
          } else {
            rnTxt.push(' ')
          }
        }
        if (match[1] in emoji.obj) {
          const v = emoji.obj[match[1]]
          rnTxt.push(this.customEmoji(v))
        } else {
          rnTxt.push(match[1])
        }
        start = index + match[1].length
      }
      if (txt != null) {
        rnTxt.push(txt.substring(start, txt.length))
      } else {
        rnTxt.push(' ')
      }
      return rnTxt.toString().replace(/,/g, '')
    },
    handleCancel () {
      // 加入班级弹窗
      this.applyVisible = false
    },
    sureFun (item) {
      if (this.currentCreateIndex === 1) {
        this.radomVis = true
        this.newGroupVis = false
      } else {
        this.$router.push({ name: 'newGroup' })
      }
    },
    refuseFun (item) {
      // 拒绝加入班级
      this.applyParam = {
        access_token: this.access_token,
        studentId: item.userId,
        userId: this.$store.state.userInfo.id,
        classId: item.classId,
        isPermit: '2'
      }
      this.apply()
    },
    apply () {
      const _this = this
      this.$http.post(requestUrl.getClassJoinApplyList, this.applyParam)
        .then((res) => {
          if (res) {
            _this.getStudentsApply()
            _this.$message.success(res.resultMessage)
            _this.applyVisible = false
          }
        })
    },
    getStudentsApply () {
      // 获取学生加入班级列表
      this.$http.post(requestUrl.getClassJoinApplyList, {
        access_token: this.access_token,
        classId: this.currentClassId
      }).then((res) => {
        if (res) {
          this.applyList = res
        }
      })
    },
    getClassIsStuJoin () {
      // 获取学生加入班级列表
      this.$http.post(requestUrl.getClassIsStuJoin, {
        access_token: this.access_token,
        classId: this.currentClassId
      }).then((res) => {
        // console.log(res)
        this.isStudentJoin = res
        this.isStudentJoin = true
        this.getStudentsApply()
      })
    },
    customEmoji (value) {
      return `<img src="faces/${value}" style="width:30px"/>`
    },
    createGroupFun (index) {
      this.currentCreateIndex = index
    },
    cancelFun () {
      this.newGroupVis = false
    },
    radomCancelFun () {
      this.groupNumber = ''
      this.radomVis = false
    },
    radomSureFun () {
      if (this.groupNumber > 20) {
        this.$message.warning('群组个数最多为20个')
        return
      }
      if (this.groupNumber > this.classMemberNumber) {
        this.$message.warning('群组个数应不大于班级人数')
      } else {
        const param = {
          access_token: this.access_token,
          classId: this.currentClassId,
          groupCount: this.groupNumber
        }
        this.$http.post(requestUrl.createRandomClassGroup, param).then(res => {
          if (res) {
            this.$message.success('创建小组成功')
            this.radomVis = false
            this.groupNumber = ''
            const groupList = this.imGroupList.concat(res)
            this.$store.commit('setGroupList', groupList)
            this.getClassList()
          }
        })
      }
    },
    debounceRadomSureFun: debounce(function () {
      // 执行发送消息的操作
      this.radomSureFun()
      // 重置输入框
      this.message = ''
    }, 800),
    getClassPersonCount () { // 获取班级下的成员
      const param = {
        access_token: this.access_token,
        classId: this.classId
      }
      this.$http.post(requestUrl.listGroupByClassId, param).then(res => {
        this.classMemberNumber = res
      })
    },
    zbFun (item) {
      this.changUserId = item.userId
      this.zbVis = true
    },
    ycFun (item) {
      this.ycVis = true
      this.delMess = item
    },
    groupChange (e) {
      console.log(e)
      this.changeGroupId = e
    },
    classCancel () {
      this.zbVis = false
    },
    groupChangeOk () {
      console.log(this)
      const param = {
        access_token: this.access_token,
        groupId: this.currentGroupId,
        changeGroupId: this.changeGroupId,
        userId: this.changUserId
      }
      this.$http.post(requestUrl.classGroupStuOfChange, param).then(res => {
        console.log(res)
        if (res) {
          this.$message.success('转组成功')
          this.zbVis = false
          this.getClaMembersByClassId()
          this.getClassList()
          if (this.group.count > 1) {
            this.group.count -= 1
            this.currentGroups[this.currentGroupIndex].studentCount = this.group.count
          } else {
            this.group.count = 1
            this.currentGroups[this.currentGroupIndex].studentCount = 1
          }
        }
      })
    },
    ycCancel () {
      this.ycVis = false
    },
    ycOk () {
      const param = {
        access_token: this.access_token,
        groupId: this.currentGroupId,
        userId: this.delMess.userId
      }
      this.$http.post(requestUrl.delClassGroupStu, param).then(res => {
        if (res) {
          this.$message.success('移除成员成功')
          this.getClaMembersByClassId()
          this.getClassList()
          this.ycVis = false
          if (this.group.count > 1) {
            this.group.count -= 1
            this.currentGroups[this.currentGroupIndex].studentCount = this.group.count
          } else {
            this.group.count = 1
            this.currentGroups[this.currentGroupIndex].studentCount = 1
          }
        }
      })
    },
    handleCommand (item) {
      console.log('本地服务器消息撤回')
      const param = {
        access_token: this.access_token,
        msgId: item.msgId
      }
      this.$http.post(requestUrl.messageRetraction, param).then((res) => {
        if (res) {
          // const message = this.shareData.msgList.find((msg) => msg.msgId === mid)
          //  message.status = 'recall'
          // message.msg = '消息已撤回'
        }
      })
    },

    recallMessage (message) {
      const _this = this
      console.log('message', message)
      const mid = message.mid || message.id
      const to = message.to
      console.log('mid', mid)
      const option = {
        mid,
        to,
        type: 'groupchat',
        force: false,
        success: function () {
          // Vue.$store.commit('updateMessageStatus', payload.message)
          const message = _this.shareData.msgList.find((msg) => msg.mid === mid)
          message.status = 'recall'
          message.msg = '消息已撤回'
          // shareState.setMsgList(message)
          console.log('环信服务器消息撤回')
          _this.handleCommand()
        },
        fail: function () {
          console.log('消息撤回失败')
        }
      }
      console.log('option', option)
      WebIM.conn.recallMessage(option)
    },
    handleMsgTimeShow (time, index) {
      // const msgList = Array.from(this.groupMessages)
      if (index !== 0) {
        const lastTime = this.groupMessages[index - 1].createDate
        return time - lastTime > 50000
          ? this.dateFormater('yyyy-MM-DD HH:mm', time)
          : false
      } else {
        return this.dateFormater('yyyy-MM-DD HH:mm', time)
      }
    },
    dateFormater (formater, t) {
      const date = t ? new Date(t * 1) : new Date()
      const Y = date.getFullYear() + ''
      const M = date.getMonth() + 1
      const D = date.getDate()
      const H = date.getHours()
      const m = date.getMinutes()
      const s = date.getSeconds()
      return formater
        .replace(/YYYY|yyyy/g, Y)
        .replace(/YY|yy/g, Y.substr(2, 2))
        .replace(/MM/g, (M < 10 ? '0' : '') + M)
        .replace(/DD/g, (D < 10 ? '0' : '') + D)
        .replace(/HH|hh/g, (H < 10 ? '0' : '') + H)
        .replace(/mm/g, (m < 10 ? '0' : '') + m)
        .replace(/ss/g, (s < 10 ? '0' : '') + s)
    }

  }
}
</script>
